import React, { useState } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  width: 100%;
  max-width: 584px;
  margin: 0 auto 2rem;
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 1rem 1.2rem 1rem 3.2rem;
  border: 1px solid #dfe1e5;
  border-radius: 24px;
  font-size: 1rem;
  outline: none;
  box-sizing: border-box;
  background: white;
  transition: all 0.3s ease;
  
  &:focus {
    box-shadow: 0 4px 12px rgba(32, 33, 36, 0.15);
    border-color: rgba(223, 225, 229, 0);
    transform: translateY(-2px);
  }
  
  &:hover:not(:focus) {
    box-shadow: 0 1px 6px rgba(32, 33, 36, 0.2);
  }
  
  &::placeholder {
    color: #9aa0a6;
    transition: color 0.2s ease;
  }
  
  &:focus::placeholder {
    color: #bdc1c6;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9aa0a6;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: color 0.2s ease;
  
  ${SearchInput}:focus + & {
    color: #4285f4;
  }
`;

const ClearButton = styled.button`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #70757a;
  cursor: pointer;
  opacity: ${props => props.visible ? '1' : '0'};
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  transition: opacity 0.2s ease, visibility 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  
  &:hover {
    background-color: rgba(60, 64, 67, 0.08);
  }
  
  &:active {
    background-color: rgba(60, 64, 67, 0.12);
  }
`;

function SearchBar({ value, onChange }) {
  const [isFocused, setIsFocused] = useState(false);
  
  const handleClear = () => {
    onChange('');
  };
  
  return (
    <SearchContainer>
      <SearchInput
        type="text"
        placeholder="Search emojis..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <SearchIcon isFocused={isFocused}>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="18" 
          height="18" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </SearchIcon>
      <ClearButton 
        visible={value.length > 0}
        onClick={handleClear}
        type="button"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="18" 
          height="18" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </ClearButton>
    </SearchContainer>
  );
}

export default SearchBar;